import { render, staticRenderFns } from "./TemplateItem.vue?vue&type=template&id=60814d9a&scoped=true&"
import script from "./TemplateItem.vue?vue&type=script&lang=js&"
export * from "./TemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItem.vue?vue&type=style&index=0&id=60814d9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60814d9a",
  null
  
)

export default component.exports